import { convertPrice, sortHashtags } from "helpers";
import { useClickAndView } from "hooks";
import { sortBy } from "lodash";
import { PersonDetailsContext } from "pages/PersonDetails";
import { useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import { Magazine } from "types";
import Badge from "./Badge";
import Button from "./Button";
import Image from "./Image";

type Props = {
  product: Magazine.ProductItem;
};

export default function ProductCard({ product }: Props) {
  // const hasDiscount = !!product.discount?.value
  const { user } = useContext(PersonDetailsContext);
  const [clickAndView] = useClickAndView({
    contentId: product.id,
    variant: "product",
    click: false,
  });
  const sortedImage = useMemo(() => {
    return sortBy(product.images ?? [], (e) => e.displayOrder);
  }, [product.images]);
  return (
    <article className="w-full py-1 px-5">
      <div className="py-1 space-y-1">
        <h3 className="text-sm font-medium text-dark">{product.title}</h3>
        <h3 className="text-sm font-medium text-[#5E6278]">
          {product.category}
        </h3>
      </div>
      <div className="w-full grid grid-cols-3 grid-rows-2 gap-1 py-1">
        {[0, 1, 2].map((index) => {
          const image = sortedImage.at(index);
          return (
            <Image
              key={index}
              src={image?.url}
              alt={product.title}
              className="w-full aspect-image object-cover rounded first:col-span-2 first:row-span-2"
            />
          );
        })}
      </div>
      <div
        dangerouslySetInnerHTML={{ __html: product.description }}
        className="text-base font-normal text-[#5E6278] whitespace-pre-wrap empty:hidden"
      />
      <div className="flex flex-wrap gap-1 py-1 empty:hidden">
        {sortHashtags(product.hashtag)?.map((e) => (
          <Badge key={e}>#{e}</Badge>
        ))}
      </div>
      <div className="flex items-center gap-2.5 py-2.5">
        <p className="flex-1 flex items-center text-sm font-medium py-2.5 px-5 rounded bg-default-theme">
          <span className="text-[#5E6278] flex-1">Price:</span>
          <span className="text-dark">{convertPrice(product.price)}</span>
        </p>
        <Button
          as={Link}
          to={{
            pathname: "product-details",
            search: `productId=${product.id}&userId=${user.id}`,
          }}
          type="button"
          variant="solid"
          color="dark"
          onClick={clickAndView}
        >
          Check
        </Button>
      </div>
      <div className="w-full h-2.5 flex items-center">
        <hr className="border-[#ECEFF2] w-full" />
      </div>
    </article>
  );
}
